import React, { useEffect } from "react";
import Modal from "react-modal";
import Pane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import "./SlidingPane.css";

const SlidingPane = (props) => {
  useEffect(() => {
    Modal.setAppElement(document.querySelector("#root"));
  }, []);

  return (
    <Pane
      className="slidePanel slidePanel-show slidePanel-right"
      width={props.width ?? "700px"}
      overlayClassName=""
      isOpen={props.open}
      title={props.title}
      subtitle={props.subtitle}
      onRequestClose={props.onRequestClose}
      closeIcon={props.closeIcon}
    >
      {props.children}
    </Pane>
  );
};

export default SlidingPane;
